webpackJsonp([200425423658985],{

/***/ 556:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"frontmatter":{"date":"2019-07-17","path":"/projects/agi-suretrack-farm","summary":"single-page marketing website","tags":["web","fedev","es6","styledcomponents","react","jsx","gatsby","static","aws","applydigital"],"taskSummary":"all development","title":"AGI Suretrack Farm","url":null,"writeupDate":"2019-09-19"},"html":"<p>This was a pretty simple one-page site.\nI was on a very compressed timeline and dependencies constantly changed,\nmaking the work a little frustrating.\nThis also meant that a lot of the nice-to-have features were cut,\nmaking the result seem a little dry to me.</p>\n<p>I’m not much of a fan of the design of this one,\nbut I think I did a good job translating it regardless.</p>\n<p>Most of the work was done in a single week.</p>\n<p>It’s a static build, generated by Gatsby, with Styled Components.</p>"}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---projects-agi-suretrack-farm-b21b903764ddbeddeccb.js